import React from 'react'
import ReactDOM from 'react-dom'
import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer'
import FlatButton from 'material-ui/FlatButton'
import Nav from './../components/nav'
import pdfFromJson from './../components/pdf'
import {resetViewportZoom} from './../routes'
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import PrintIcon from 'material-ui/svg-icons/action/print';
import DesktopIcon from 'material-ui/svg-icons/hardware/desktop-windows';
import MobileIcon from 'material-ui/svg-icons/hardware/smartphone';
import logo from '../images/morrisons_logo_white_custom.png'
import CircularProgress from 'material-ui/CircularProgress';
import {save} from '../store'
import {browserHistory} from 'react-router'
import config from '../config'
import ReactGA from 'react-ga'

const actionButtonsStyle = {
    marginTop : "0px",
    marginRight : "-8px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
}

const homeURL = config.landing_page_url

export default class extends React.Component {

    constructor() {
        super()
        this.state = {show_menu: false}
        this.is_downloading = false;
    }

    toggleMenu() {
        ReactGA.event({ category: 'Navigation', action: 'Hamburger Menu', label: this.state.show_menu ? 'Close' : 'Open'});
        this.setState( {show_menu: !this.state.show_menu} )
    }

    downloadPDF(){
        if(!this.is_downloading){

            ReactGA.pageview(location.pathname + "#download")

            this.is_downloading = true;
            const doc = pdfFromJson(this.props.store.current_user, this.props.payslip);
            window.pdfMake.createPdf(doc).download('payslip.pdf');
            setTimeout(() => this.is_downloading = false, 3000)
        }
    }

    print(){
        save({print_payslip: this.props.payslip})
        browserHistory.push('/print-payslip')
    }

    actionButtons() {return (
        <div id="action_menu" className="layout-row action_menu">
            <FlatButton
              onTouchTap={() => this.downloadPDF()}
              label="Download"
              style={{"color": "white"}}
              icon={<DownloadIcon/>}
            />
            <FlatButton
              id="print_view_button"
              onTouchTap={() => this.print()}
              label="Print"
              style={{"color": "white"}}
              icon={<PrintIcon/>}
            />
        </div>
    )}

    toggleDesktopView() {
        ReactGA.event({ category: 'Navigation', action: 'Toggle Layout', label: !this.props.store.desktopLayout ? 'Desktop' : 'Mobile'});
        setTimeout(() => {
            resetViewportZoom()
            save({desktopLayout: !this.props.store.desktopLayout})
            ReactDOM.findDOMNode(this.refs.main_content).scrollTop = 0
        }, 500)
    }

    actionMenu(){return (

        <IconMenu id="action_menu" className="action_menu" iconButtonElement={ <IconButton><MoreVertIcon /></IconButton> }
                  targetOrigin={{horizontal: 'right', vertical: 'top'}}
                  anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                  width={168}>

                <MenuItem 
                    onTouchTap={() => this.downloadPDF()}
                    primaryText="Download" 
                    rightIcon={<DownloadIcon/>}
                />
                <MenuItem 
                    id="print_view_button"
                    onTouchTap={() => this.print()} 
                    primaryText="Print" 
                    rightIcon={<PrintIcon/>}
                />
                <MenuItem 
                    id={this.props.store.desktopLayout ? "mobile_layout_button" : "desktop_layout_button"} 
                    onTouchTap={() => this.toggleDesktopView()} 
                    primaryText={this.props.store.desktopLayout ? "Mobile Layout" : "Desktop Layout"} 
                    rightIcon={this.props.store.desktopLayout ? <MobileIcon/> : <DesktopIcon/>}
                />

            </IconMenu>
    )}

    fixedNav(title, showAppBarActions) {
        return(
            <div className="layout-row flex">
                <div className="fixed-nav layout-column">
                    <AppBar className="toolbar-height" 
                    iconElementLeft={
                        <div className="horrizontal-padding">
                            <a href={homeURL} onClick={() => this.home()}><img alt="morrisons logo" height="50" src={logo}></img></a>
                        </div>
                    }>
                    </AppBar>
                    <Nav current_user={this.props.store.current_user} location={this.props.location} latest_payslip={this.props.store.latest_payslip}/>
                </div>
                <div className="layout-column flex">
                    {showAppBarActions ?
                        <AppBar id="title_bar" className="toolbar-height" title={title} iconElementRight={this.actionButtons()}
                        iconStyleRight={actionButtonsStyle} showMenuIconButton={false}/>
                        :
                        <AppBar id="title_bar" className="toolbar-height" title={title} showMenuIconButton={false}/>
                    }
                    {this.mainContent()}
                </div>
            </div>
        )
    }

    home(){
        ReactGA.event({ category: 'Navigation', action: 'Nav Icon Click', label: "Home"});
        window.location.href=config.landing_page_url
    }

    drawerNav(title, showAppBarActions) {
        return(
            <div className="layout-row flex">
                <Drawer className="inner-layout-column" 
                    open={this.state.show_menu} onRequestChange={() => this.toggleMenu()}  docked={false} >
                    <AppBar className="toolbar-height" 
                    onRightIconButtonTouchTap={() => this.toggleMenu()}
                            iconElementRight={<IconButton><NavigationMenu /></IconButton>}
                            iconElementLeft={
                                <div className="horrizontal-padding">
                                    <a href={homeURL} onClick={() => this.home()}><img alt="morrisons logo" height="50" src={logo}></img></a>
                                </div>
                            }>
                    </AppBar>
                    <Nav current_user={this.props.store.current_user} latest_payslip={this.props.store.latest_payslip} location={this.props.location}/>
                </Drawer>

                <div className="layout-column flex">
                    {showAppBarActions ?
                        <AppBar id="title_bar" className="toolbar-height" 
                            title={title} iconElementRight={this.actionMenu()}
                                onLeftIconButtonTouchTap={() => this.toggleMenu()}/>
                        :
                        <AppBar id="title_bar" className="toolbar-height"
                            title={title} onLeftIconButtonTouchTap={() => this.toggleMenu()}/>
                    }
                    {this.mainContent()}
                </div>
            </div>
        )
    }

    mainContent(){
        if(!this.props.ready || this.props.store.current_user.show_spinner ){
            return (
                <div id="main_content" ref="main_content" className="spinner flex layout-column scrollable layout-align-center-center">
                    <CircularProgress size={80} thickness={7} />
                </div>
            )
        }
        if(this.props.errorMessage){
            return (
                <div id="main_content" ref="main_content" className="flex layout-column scrollable layout-align-center-center">
                    {this.props.errorMessage}
                </div>
            )
        }

        const body = React.createFactory(this.props.body)({...this.props})

        return (
            <div id="main_content" ref="main_content" className="flex layout-column scrollable">
                {body}
            </div>
        )
    }

    render() {
        const title = this.props.title;
        const showAppBarActions = this.props.showAppBarActions && !this.props.errorMessage && this.props.ready;

        return this.props.browser.greaterThan.medium ?
            this.fixedNav(title, showAppBarActions)
            :
            this.drawerNav(title, showAppBarActions)
    }
}



// WEBPACK FOOTER //
// ./src/components/layout.js